'use client';

import { CareersEditProvider } from '../../contexts/careers-edit-provider';
import type { CareersData } from '../../types/careers-types';
import { CareersPageContent } from '../views/careers-page-content';

type CareersPageClientProps = {
	handle: string;
	isTokenExist: boolean;
	initialData: CareersData;
	/** Chromeless render for embedding (e.g. the agent's preview sheet): no admin affordances. */
	embedded?: boolean;
};

export function CareersPageClient({
	handle,
	isTokenExist,
	initialData,
	embedded = false,
}: CareersPageClientProps) {
	return (
		<CareersEditProvider
			mode="view"
			handle={handle}
			isTokenExist={isTokenExist}
			initialData={initialData}
			embedded={embedded}
		>
			<CareersPageContent />
		</CareersEditProvider>
	);
}
